import {
	SEARCH_RESULTS_REQUEST,
	SEARCH_RESULTS_REQUEST_SUCCESS,
	SEARCH_RESULTS_REQUEST_FAILURE,
	SEARCH_QUERY_UPDATE,
	SEARCH_RESULTS_POPUP_OPEN,
	SEARCH_RESULTS_POPUP_CLOSE,
	SEARCH_TAB_HASH_UPDATE,
	SEARCH_PAGINATION_UPDATE,
	CLEAR_SEARCH_AND_SEARCH_FILTER,
} from 'constants/actions';
import * as api from 'api';

export function getSearchResults(requestData, entityType) {
	return (dispatch) => {
		const url = entityType === 'appeal'
			? api.mw.request.requestFilterApply
			: api.mw.search.search;

		dispatch({
			type: SEARCH_RESULTS_REQUEST,
			entityType,
		});

		return dispatch(url.initiate(requestData))
			.unwrap()
			.then(response => {
				if (response.success && Array.isArray(response.result)) {
					dispatch({
						type: SEARCH_RESULTS_REQUEST_SUCCESS,
						results: response.result,
						total: response.total,
						entityType,
					});
				} else {
					throw new Error('Search results error');
				}
			})
			.catch(() => {
				dispatch({
					type: SEARCH_RESULTS_REQUEST_FAILURE,
				});
			});
	};
}

export function clearSearchAndSearchFilters(id) {
	return dispatch => {
		dispatch({
			type: CLEAR_SEARCH_AND_SEARCH_FILTER,
			id,
		});
	};
}

export function setEmptySearchResults(entityType) {
	return dispatch => {
		dispatch({
			type: SEARCH_RESULTS_REQUEST_SUCCESS,
			results: [],
			total: 0,
			entityType,
		});
	};
}

export const updateSearchQuery = (query, id) => ({
	type: SEARCH_QUERY_UPDATE,
	query,
	id,
});

export const openSearchResultsPopup = () => ({
	type: SEARCH_RESULTS_POPUP_OPEN,
});

export const closeSearchResultsPopup = () => ({
	type: SEARCH_RESULTS_POPUP_CLOSE,
});

export const updateSearchTabHash = tabHash => ({
	type: SEARCH_TAB_HASH_UPDATE,
	tabHash,
});

export const updatePagination = pagination => ({
	type: SEARCH_PAGINATION_UPDATE,
	pagination,
});
